module.exports = __webpack_public_path__ + "media/images/video3-964995f6bd0b8fb3ce2c1460450130f0.png";